// extracted by mini-css-extract-plugin
export default {"reCaptchaContainer":"cN_kP"};